import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import FireflyReportsComp from './FireflyReportsComp'

function FireflyReports() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu />
        <div className='theMainContainer'>
          <Dashnav />
          <AdmissionTopNotice />
          <FireflyReportsComp />
        </div>
      </div>
    </div>
  )
}

export default FireflyReports
